import { useField, useFormikContext } from 'formik';

import { isDefined } from '../../utils/types.js';

export interface useFormFieldStateProps {
  name: string;
}

export function useFormFieldState<TValue>(props: useFormFieldStateProps) {
  const { name } = props;

  const [field, { touched, error }] = useField<TValue>(name);
  const { setFieldValue, setFieldTouched, setFieldError } = useFormikContext();

  const isErrorVisible = touched && isDefined(error);

  const setValue = async (value: TValue) => {
    await setFieldValue(name, value);
  };

  const setTouched = async () => {
    await setFieldTouched(name, true);
  };

  const setError = (error: string) => {
    setFieldError(name, error);
  };

  return {
    fieldProps: field,
    value: field.value,
    setValue,
    setTouched,
    setError,
    isErrorVisible,
    errorMessage: isErrorVisible ? error : undefined,
  };
}
